import { render, staticRenderFns } from "./L2tpStaticIpService.vue?vue&type=template&id=5fb589ea&"
import script from "./L2tpStaticIpService.vue?vue&type=script&lang=js&"
export * from "./L2tpStaticIpService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports